import FormSection from './FormSection'
import { translations } from '../../data/translations'

const SEOSection = ({ formData, updateFormData, language }) => {
  const t = translations[language]?.seo || translations.de.seo

  const handleCheckboxChange = (field, value) => {
    const currentValues = formData[field] || []
    const newValues = currentValues.includes(value)
      ? currentValues.filter(v => v !== value)
      : [...currentValues, value]
    updateFormData(field, newValues)
  }

  return (
    <FormSection
      title={t.title}
      subtitle={t.subtitle}
    >
      {/* 10.1 SEO-Anforderungen */}
      <div className="subsection">
        <div className="subsection-title">{t.subtitle1}</div>
        
        <div className="form-group">
          <label>{t.seoLeistungen}</label>
          <div className="checkbox-group" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}>
            {t.seoOptionen.map(option => (
              <div key={option.value} className="checkbox-item">
                <input
                  type="checkbox"
                  id={`seo-${option.value}`}
                  checked={(formData.seo || []).includes(option.value)}
                  onChange={() => handleCheckboxChange('seo', option.value)}
                />
                <label htmlFor={`seo-${option.value}`}>{option.label}</label>
              </div>
            ))}
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="seo_keywords">{t.seoKeywords}</label>
          <textarea
            id="seo_keywords"
            name="seo_keywords"
            value={formData.seo_keywords || ''}
            onChange={(e) => updateFormData('seo_keywords', e.target.value)}
            placeholder={t.seoKeywordsPlaceholder}
            style={{ minHeight: '80px' }}
          />
          <div className="help-text">{t.seoKeywordsHelp}</div>
        </div>

        <div className="form-group">
          <label htmlFor="seo_zielregion">{t.seoZielregion}</label>
          <input
            type="text"
            id="seo_zielregion"
            name="seo_zielregion"
            value={formData.seo_zielregion || ''}
            onChange={(e) => updateFormData('seo_zielregion', e.target.value)}
            placeholder={t.seoZielregionPlaceholder}
          />
        </div>
      </div>

      {/* 10.2 Marketing-Tools & Tracking */}
      <div className="subsection">
        <div className="subsection-title">{t.subtitle2}</div>
        
        <div className="form-group">
          <label>{t.marketingTools}</label>
          <div className="checkbox-group" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}>
            {t.marketingToolsOptionen.map(option => (
              <div key={option.value} className="checkbox-item">
                <input
                  type="checkbox"
                  id={`mt-${option.value}`}
                  checked={(formData.marketing_tools || []).includes(option.value)}
                  onChange={() => handleCheckboxChange('marketing_tools', option.value)}
                />
                <label htmlFor={`mt-${option.value}`}>{option.label}</label>
              </div>
            ))}
          </div>
        </div>

        <div className="form-group">
          <label>{t.socialMedia}</label>
          <div className="checkbox-group" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))' }}>
            {t.socialMediaOptionen.map(option => (
              <div key={option.value} className="checkbox-item">
                <input
                  type="checkbox"
                  id={`sm-${option.value}`}
                  checked={(formData.social_media || []).includes(option.value)}
                  onChange={() => handleCheckboxChange('social_media', option.value)}
                />
                <label htmlFor={`sm-${option.value}`}>{option.label}</label>
              </div>
            ))}
          </div>
          <input
            type="text"
            name="social_media_urls"
            value={formData.social_media_urls || ''}
            onChange={(e) => updateFormData('social_media_urls', e.target.value)}
            placeholder={t.socialMediaUrls}
            style={{ marginTop: '10px' }}
          />
        </div>
      </div>
    </FormSection>
  )
}

export default SEOSection
